function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
/**
 * Faucet database. Schemas: sql/01_registrations.sql, sql/02_activity.sql
 * registrations: one Saito public key → one registration → at most one issuance
 * activity: request/payment history for Admin
 */
var FaucetDB = /*#__PURE__*/function () {
  function FaucetDB(app, mod) {
    _classCallCheck(this, FaucetDB);
    this.app = app;
    this.mod = mod;
  }
  return _createClass(FaucetDB, [{
    key: "initialize",
    value: function () {
      var _initialize = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var filesystem, _i, _arr, file, sqlPath, duplicates, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              if (!this.app.BROWSER) {
                _context.n = 1;
                break;
              }
              return _context.a(2);
            case 1:
              _context.p = 1;
              filesystem = this.app.storage.returnFileSystem();
              if (filesystem) {
                _context.n = 2;
                break;
              }
              return _context.a(2);
            case 2:
              _i = 0, _arr = ['01_registrations.sql', '02_activity.sql'];
            case 3:
              if (!(_i < _arr.length)) {
                _context.n = 6;
                break;
              }
              file = _arr[_i];
              sqlPath = "".concat(__dirname, "/../sql/").concat(file);
              if (filesystem.existsSync(sqlPath)) {
                _context.n = 4;
                break;
              }
              return _context.a(3, 5);
            case 4:
              _context.n = 5;
              return this.app.storage.executeDatabase(filesystem.readFileSync(sqlPath, 'utf8'), this.mod.returnSlug());
            case 5:
              _i++;
              _context.n = 3;
              break;
            case 6:
              _context.n = 7;
              return this.app.storage.executeDatabase("DROP TABLE IF EXISTS claims;\n         DROP TABLE IF EXISTS auth_requests;\n         DROP TABLE IF EXISTS identities;\n         DROP TABLE IF EXISTS issuances;", this.mod.returnSlug());
            case 7:
              _context.n = 8;
              return this.app.storage.queryDatabase("SELECT provider, provider_user_id, COUNT(*) AS cnt\n           FROM registrations\n          GROUP BY provider, provider_user_id\n         HAVING COUNT(*) > 1", {}, this.mod.returnSlug());
            case 8:
              duplicates = _context.v;
              if (!(Array.isArray(duplicates) && duplicates.length > 0)) {
                _context.n = 9;
                break;
              }
              console.error('FAUCET: cannot add UNIQUE(provider, provider_user_id) — duplicates exist');
              return _context.a(2);
            case 9:
              _context.n = 10;
              return this.app.storage.executeDatabase("DROP INDEX IF EXISTS registrations_provider_uid_idx;\n         CREATE UNIQUE INDEX IF NOT EXISTS registrations_provider_uid_uidx\n           ON registrations (provider, provider_user_id);", this.mod.returnSlug());
            case 10:
              _context.n = 12;
              break;
            case 11:
              _context.p = 11;
              _t = _context.v;
              console.error('FAUCET: initialize failed', _t);
            case 12:
              return _context.a(2);
          }
        }, _callee, this, [[1, 11]]);
      }));
      function initialize() {
        return _initialize.apply(this, arguments);
      }
      return initialize;
    }()
  }, {
    key: "getRecord",
    value: function () {
      var _getRecord = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var identity,
          publickey,
          rows,
          provider,
          provider_user_id,
          _rows,
          _args2 = arguments;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              identity = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : {};
              if (!this.app.BROWSER) {
                _context2.n = 1;
                break;
              }
              return _context2.a(2, null);
            case 1:
              publickey = String(identity.publickey || '').trim();
              if (!publickey) {
                _context2.n = 3;
                break;
              }
              _context2.n = 2;
              return this.app.storage.queryDatabase("SELECT * FROM registrations WHERE publickey = $publickey LIMIT 1", {
                $publickey: publickey
              }, this.mod.returnSlug());
            case 2:
              rows = _context2.v;
              if (!(rows !== null && rows !== void 0 && rows[0])) {
                _context2.n = 3;
                break;
              }
              return _context2.a(2, rows[0]);
            case 3:
              provider = String(identity.provider || '').trim();
              provider_user_id = String(identity.provider_user_id || '').trim();
              if (!(provider && provider_user_id)) {
                _context2.n = 5;
                break;
              }
              _context2.n = 4;
              return this.app.storage.queryDatabase("SELECT * FROM registrations WHERE provider = $provider AND provider_user_id = $provider_user_id LIMIT 1", {
                $provider: provider,
                $provider_user_id: provider_user_id
              }, this.mod.returnSlug());
            case 4:
              _rows = _context2.v;
              return _context2.a(2, (_rows === null || _rows === void 0 ? void 0 : _rows[0]) || null);
            case 5:
              return _context2.a(2, null);
          }
        }, _callee2, this);
      }));
      function getRecord() {
        return _getRecord.apply(this, arguments);
      }
      return getRecord;
    }()
  }, {
    key: "insertRecord",
    value: function () {
      var _insertRecord = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var identity,
          publickey,
          provider,
          provider_user_id,
          now,
          _args3 = arguments,
          _t2;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              identity = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : {};
              if (!this.app.BROWSER) {
                _context3.n = 1;
                break;
              }
              return _context3.a(2, null);
            case 1:
              publickey = String(identity.publickey || '').trim();
              provider = String(identity.provider || '').trim();
              provider_user_id = String(identity.provider_user_id || '').trim();
              if (!(!publickey || !provider || !provider_user_id)) {
                _context3.n = 2;
                break;
              }
              return _context3.a(2, null);
            case 2:
              now = Date.now();
              _context3.p = 3;
              _context3.n = 4;
              return this.app.storage.runDatabase("INSERT INTO registrations (\n           publickey, provider, provider_user_id, provider_username,\n           provider_display_name, provider_account_created_at, authenticated_at,\n           issuance_status, issuance_amount, issuance_tx_signature, issued_at,\n           created_at, updated_at)\n         VALUES (\n           $publickey, $provider, $provider_user_id, $provider_username,\n           $provider_display_name, $provider_account_created_at, $authenticated_at,\n           'eligible', '', '', 0, $created_at, $updated_at)", {
                $publickey: publickey,
                $provider: provider,
                $provider_user_id: provider_user_id,
                $provider_username: String(identity.provider_username || ''),
                $provider_display_name: String(identity.provider_display_name || ''),
                $provider_account_created_at: Number(identity.provider_account_created_at) || 0,
                $authenticated_at: now,
                $created_at: now,
                $updated_at: now
              }, this.mod.returnSlug());
            case 4:
              _context3.n = 6;
              break;
            case 5:
              _context3.p = 5;
              _t2 = _context3.v;
              console.log('FAUCET: insertRecord failed', _t2);
              return _context3.a(2, null);
            case 6:
              return _context3.a(2, true);
          }
        }, _callee3, this, [[3, 5]]);
      }));
      function insertRecord() {
        return _insertRecord.apply(this, arguments);
      }
      return insertRecord;
    }()
    /**
     * Free mode permits one successful allocation per rolling cooldown period.
     * Re-arming is conditional; the later eligible-to-pending transition is the
     * final guard against concurrent payouts.
     */
  }, {
    key: "prepareFreeUseClaim",
    value: function () {
      var _prepareFreeUseClaim = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var _record4;
        var identity,
          now,
          cooldown_ms,
          record,
          inserted,
          status_time,
          retry_at,
          _record,
          _record2,
          _record3,
          reset,
          _args4 = arguments;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              identity = _args4.length > 0 && _args4[0] !== undefined ? _args4[0] : {};
              now = _args4.length > 1 && _args4[1] !== undefined ? _args4[1] : Date.now();
              cooldown_ms = _args4.length > 2 && _args4[2] !== undefined ? _args4[2] : 86400000;
              _context4.n = 1;
              return this.getRecord(identity);
            case 1:
              record = _context4.v;
              if (record) {
                _context4.n = 3;
                break;
              }
              _context4.n = 2;
              return this.insertRecord(identity);
            case 2:
              inserted = _context4.v;
              return _context4.a(2, inserted ? {
                eligible: true,
                retry_at: 0,
                reason: 'new'
              } : {
                eligible: false,
                retry_at: 0,
                reason: 'insert_failed'
              });
            case 3:
              if (!(record.issuance_status === 'eligible')) {
                _context4.n = 4;
                break;
              }
              return _context4.a(2, {
                eligible: true,
                retry_at: 0,
                reason: 'eligible'
              });
            case 4:
              status_time = record.issuance_status === 'issued' ? Number(record.issued_at) || 0 : Number(record.updated_at) || 0;
              retry_at = status_time + cooldown_ms;
              if (!(status_time === 0 || now >= retry_at)) {
                _context4.n = 9;
                break;
              }
              _context4.n = 5;
              return this.updateRecord({
                publickey: record.publickey,
                issuance_status: record.issuance_status
              }, {
                issuance_status: 'eligible'
              });
            case 5:
              reset = _context4.v;
              if (!reset) {
                _context4.n = 6;
                break;
              }
              return _context4.a(2, {
                eligible: true,
                retry_at: 0,
                reason: 'cooldown_elapsed'
              });
            case 6:
              _context4.n = 7;
              return this.getRecord(identity);
            case 7:
              record = _context4.v;
              if (!(((_record = record) === null || _record === void 0 ? void 0 : _record.issuance_status) === 'eligible')) {
                _context4.n = 8;
                break;
              }
              return _context4.a(2, {
                eligible: true,
                retry_at: 0,
                reason: 'eligible'
              });
            case 8:
              status_time = ((_record2 = record) === null || _record2 === void 0 ? void 0 : _record2.issuance_status) === 'issued' ? Number(record.issued_at) || 0 : Number((_record3 = record) === null || _record3 === void 0 ? void 0 : _record3.updated_at) || 0;
              retry_at = status_time + cooldown_ms;
            case 9:
              return _context4.a(2, {
                eligible: false,
                retry_at: retry_at,
                reason: ((_record4 = record) === null || _record4 === void 0 ? void 0 : _record4.issuance_status) === 'pending' ? 'pending' : 'cooldown'
              });
          }
        }, _callee4, this);
      }));
      function prepareFreeUseClaim() {
        return _prepareFreeUseClaim.apply(this, arguments);
      }
      return prepareFreeUseClaim;
    }()
  }, {
    key: "updateRecord",
    value: function () {
      var _updateRecord = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var where,
          changes,
          params,
          clauses,
          _i2,
          _arr2,
          col,
          sets,
          _i3,
          _arr3,
          _col,
          res,
          _args5 = arguments;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              where = _args5.length > 0 && _args5[0] !== undefined ? _args5[0] : {};
              changes = _args5.length > 1 && _args5[1] !== undefined ? _args5[1] : {};
              if (!this.app.BROWSER) {
                _context5.n = 1;
                break;
              }
              return _context5.a(2, false);
            case 1:
              params = {};
              clauses = [];
              _i2 = 0, _arr2 = ['publickey', 'issuance_status'];
            case 2:
              if (!(_i2 < _arr2.length)) {
                _context5.n = 5;
                break;
              }
              col = _arr2[_i2];
              if (!(!Object.prototype.hasOwnProperty.call(where, col) || where[col] == null)) {
                _context5.n = 3;
                break;
              }
              return _context5.a(3, 4);
            case 3:
              clauses.push("".concat(col, " = $").concat(col));
              params["$".concat(col)] = where[col];
            case 4:
              _i2++;
              _context5.n = 2;
              break;
            case 5:
              if (clauses.length) {
                _context5.n = 6;
                break;
              }
              return _context5.a(2, false);
            case 6:
              sets = [];
              _i3 = 0, _arr3 = ['issuance_status', 'issuance_amount', 'issuance_tx_signature', 'issued_at'];
            case 7:
              if (!(_i3 < _arr3.length)) {
                _context5.n = 10;
                break;
              }
              _col = _arr3[_i3];
              if (!(!Object.prototype.hasOwnProperty.call(changes, _col) || changes[_col] === undefined)) {
                _context5.n = 8;
                break;
              }
              return _context5.a(3, 9);
            case 8:
              sets.push("".concat(_col, " = $").concat(_col, "_set"));
              params["$".concat(_col, "_set")] = changes[_col];
            case 9:
              _i3++;
              _context5.n = 7;
              break;
            case 10:
              if (sets.length) {
                _context5.n = 11;
                break;
              }
              return _context5.a(2, false);
            case 11:
              sets.push('updated_at = $updated_at');
              params.$updated_at = Date.now();
              _context5.n = 12;
              return this.app.storage.runDatabase("UPDATE registrations SET ".concat(sets.join(', '), " WHERE ").concat(clauses.join(' AND ')), params, this.mod.returnSlug());
            case 12:
              res = _context5.v;
              return _context5.a(2, Number((res === null || res === void 0 ? void 0 : res.changes) || 0) === 1);
          }
        }, _callee5, this);
      }));
      function updateRecord() {
        return _updateRecord.apply(this, arguments);
      }
      return updateRecord;
    }()
  }, {
    key: "insertActivity",
    value: function () {
      var _insertActivity = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
        var row,
          now,
          res,
          _args6 = arguments;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              row = _args6.length > 0 && _args6[0] !== undefined ? _args6[0] : {};
              if (!this.app.BROWSER) {
                _context6.n = 1;
                break;
              }
              return _context6.a(2, null);
            case 1:
              now = Date.now();
              _context6.n = 2;
              return this.app.storage.runDatabase("INSERT INTO activity (\n         created_at, updated_at,\n         requester_publickey, provider, provider_user_id, provider_username,\n         requested_amount, request_status, request_reason,\n         request_tx_signature, request_block_id, request_block_hash, request_longest_chain,\n         payment_status, payment_tx_signature, paid_at,\n         payment_block_id, payment_block_hash, payment_longest_chain)\n       VALUES (\n         $created_at, $updated_at,\n         $requester_publickey, $provider, $provider_user_id, $provider_username,\n         $requested_amount, $request_status, $request_reason,\n         $request_tx_signature, $request_block_id, $request_block_hash, $request_longest_chain,\n         $payment_status, $payment_tx_signature, $paid_at,\n         $payment_block_id, $payment_block_hash, $payment_longest_chain)", {
                $created_at: now,
                $updated_at: now,
                $requester_publickey: String(row.requester_publickey || ''),
                $provider: String(row.provider || ''),
                $provider_user_id: String(row.provider_user_id || ''),
                $provider_username: String(row.provider_username || ''),
                $requested_amount: String(row.requested_amount || ''),
                $request_status: String(row.request_status || ''),
                $request_reason: String(row.request_reason || ''),
                $request_tx_signature: String(row.request_tx_signature || ''),
                $request_block_id: String(row.request_block_id || ''),
                $request_block_hash: String(row.request_block_hash || ''),
                $request_longest_chain: row.request_longest_chain ? 1 : 0,
                $payment_status: String(row.payment_status || 'none'),
                $payment_tx_signature: String(row.payment_tx_signature || ''),
                $paid_at: Number(row.paid_at) || 0,
                $payment_block_id: String(row.payment_block_id || ''),
                $payment_block_hash: String(row.payment_block_hash || ''),
                $payment_longest_chain: row.payment_longest_chain ? 1 : 0
              }, this.mod.returnSlug());
            case 2:
              res = _context6.v;
              return _context6.a(2, Number((res === null || res === void 0 ? void 0 : res.lastID) || 0) || null);
          }
        }, _callee6, this);
      }));
      function insertActivity() {
        return _insertActivity.apply(this, arguments);
      }
      return insertActivity;
    }()
  }, {
    key: "updateActivity",
    value: function () {
      var _updateActivity = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7(id) {
        var changes,
          allowed,
          sets,
          params,
          _i4,
          _allowed,
          col,
          res,
          _args7 = arguments;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.n) {
            case 0:
              changes = _args7.length > 1 && _args7[1] !== undefined ? _args7[1] : {};
              if (!(this.app.BROWSER || !id)) {
                _context7.n = 1;
                break;
              }
              return _context7.a(2, false);
            case 1:
              allowed = ['request_status', 'request_reason', 'request_tx_signature', 'request_block_id', 'request_block_hash', 'request_longest_chain', 'payment_status', 'payment_tx_signature', 'paid_at', 'payment_block_id', 'payment_block_hash', 'payment_longest_chain'];
              sets = [];
              params = {
                $id: id
              };
              _i4 = 0, _allowed = allowed;
            case 2:
              if (!(_i4 < _allowed.length)) {
                _context7.n = 5;
                break;
              }
              col = _allowed[_i4];
              if (!(!Object.prototype.hasOwnProperty.call(changes, col) || changes[col] === undefined)) {
                _context7.n = 3;
                break;
              }
              return _context7.a(3, 4);
            case 3:
              sets.push("".concat(col, " = $").concat(col));
              if (col === 'request_longest_chain' || col === 'payment_longest_chain') {
                params["$".concat(col)] = changes[col] ? 1 : 0;
              } else {
                params["$".concat(col)] = changes[col];
              }
            case 4:
              _i4++;
              _context7.n = 2;
              break;
            case 5:
              if (sets.length) {
                _context7.n = 6;
                break;
              }
              return _context7.a(2, false);
            case 6:
              sets.push('updated_at = $updated_at');
              params.$updated_at = Date.now();
              _context7.n = 7;
              return this.app.storage.runDatabase("UPDATE activity SET ".concat(sets.join(', '), " WHERE id = $id"), params, this.mod.returnSlug());
            case 7:
              res = _context7.v;
              return _context7.a(2, Number((res === null || res === void 0 ? void 0 : res.changes) || 0) === 1);
          }
        }, _callee7, this);
      }));
      function updateActivity(_x) {
        return _updateActivity.apply(this, arguments);
      }
      return updateActivity;
    }()
  }, {
    key: "findOpenActivity",
    value: function () {
      var _findOpenActivity = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8(publickey) {
        var pk, rows;
        return _regenerator().w(function (_context8) {
          while (1) switch (_context8.n) {
            case 0:
              if (!this.app.BROWSER) {
                _context8.n = 1;
                break;
              }
              return _context8.a(2, null);
            case 1:
              pk = String(publickey || '').trim();
              if (pk) {
                _context8.n = 2;
                break;
              }
              return _context8.a(2, null);
            case 2:
              _context8.n = 3;
              return this.app.storage.queryDatabase("SELECT * FROM activity\n        WHERE requester_publickey = $publickey\n          AND request_status = 'accepted'\n          AND payment_status = 'none'\n        ORDER BY id DESC LIMIT 1", {
                $publickey: pk
              }, this.mod.returnSlug());
            case 3:
              rows = _context8.v;
              return _context8.a(2, (rows === null || rows === void 0 ? void 0 : rows[0]) || null);
          }
        }, _callee8, this);
      }));
      function findOpenActivity(_x2) {
        return _findOpenActivity.apply(this, arguments);
      }
      return findOpenActivity;
    }()
  }, {
    key: "markPaymentIncluded",
    value: function () {
      var _markPaymentIncluded = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9(signature, block_id, block_hash) {
        var sig, res;
        return _regenerator().w(function (_context9) {
          while (1) switch (_context9.n) {
            case 0:
              if (!this.app.BROWSER) {
                _context9.n = 1;
                break;
              }
              return _context9.a(2, false);
            case 1:
              sig = String(signature || '').trim();
              if (sig) {
                _context9.n = 2;
                break;
              }
              return _context9.a(2, false);
            case 2:
              _context9.n = 3;
              return this.app.storage.runDatabase("UPDATE activity\n          SET payment_status = 'included',\n              payment_block_id = $block_id,\n              payment_block_hash = $block_hash,\n              payment_longest_chain = 1,\n              updated_at = $updated_at\n        WHERE payment_tx_signature = $signature", {
                $signature: sig,
                $block_id: String(block_id || ''),
                $block_hash: String(block_hash || ''),
                $updated_at: Date.now()
              }, this.mod.returnSlug());
            case 3:
              res = _context9.v;
              return _context9.a(2, Number((res === null || res === void 0 ? void 0 : res.changes) || 0) > 0);
          }
        }, _callee9, this);
      }));
      function markPaymentIncluded(_x3, _x4, _x5) {
        return _markPaymentIncluded.apply(this, arguments);
      }
      return markPaymentIncluded;
    }()
  }, {
    key: "markChainState",
    value: function () {
      var _markChainState = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee0(block_id, block_hash, longest_chain) {
        var hash, id, lc, now, db;
        return _regenerator().w(function (_context0) {
          while (1) switch (_context0.n) {
            case 0:
              if (!this.app.BROWSER) {
                _context0.n = 1;
                break;
              }
              return _context0.a(2);
            case 1:
              hash = String(block_hash || '').trim();
              if (hash) {
                _context0.n = 2;
                break;
              }
              return _context0.a(2);
            case 2:
              id = String(block_id || '');
              lc = longest_chain ? 1 : 0;
              now = Date.now();
              db = this.mod.returnSlug();
              _context0.n = 3;
              return this.app.storage.runDatabase("UPDATE activity\n          SET request_longest_chain = $lc, updated_at = $updated_at\n        WHERE request_block_hash = $hash AND request_block_id = $id", {
                $lc: lc,
                $updated_at: now,
                $hash: hash,
                $id: id
              }, db);
            case 3:
              _context0.n = 4;
              return this.app.storage.runDatabase("UPDATE activity\n          SET payment_longest_chain = $lc,\n              payment_status = CASE WHEN $lc = 1 THEN 'included' ELSE 'orphaned' END,\n              updated_at = $updated_at\n        WHERE payment_block_hash = $hash\n          AND payment_block_id = $id\n          AND payment_status IN ('included', 'orphaned')", {
                $lc: lc,
                $updated_at: now,
                $hash: hash,
                $id: id
              }, db);
            case 4:
              return _context0.a(2);
          }
        }, _callee0, this);
      }));
      function markChainState(_x6, _x7, _x8) {
        return _markChainState.apply(this, arguments);
      }
      return markChainState;
    }()
  }, {
    key: "listActivity",
    value: function () {
      var _listActivity = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee1() {
        var filter,
          limit,
          cap,
          where,
          _args1 = arguments,
          _t3;
        return _regenerator().w(function (_context1) {
          while (1) switch (_context1.n) {
            case 0:
              filter = _args1.length > 0 && _args1[0] !== undefined ? _args1[0] : 'recent';
              limit = _args1.length > 1 && _args1[1] !== undefined ? _args1[1] : 50;
              if (!this.app.BROWSER) {
                _context1.n = 1;
                break;
              }
              return _context1.a(2, []);
            case 1:
              cap = Math.min(Math.max(Number(limit) || 50, 1), 50);
              where = '1=1';
              if (filter === 'pending') {
                where = "payment_status IN ('none', 'queued', 'broadcast') AND request_status != 'rejected'";
              } else if (filter === 'completed') {
                where = "payment_status = 'included' AND payment_longest_chain = 1";
              } else if (filter === 'failed') {
                where = "request_status = 'rejected' OR payment_status IN ('failed', 'orphaned')";
              }
              _context1.n = 2;
              return this.app.storage.queryDatabase("SELECT * FROM activity WHERE ".concat(where, " ORDER BY id DESC LIMIT $limit"), {
                $limit: cap
              }, this.mod.returnSlug());
            case 2:
              _t3 = _context1.v;
              if (_t3) {
                _context1.n = 3;
                break;
              }
              _t3 = [];
            case 3:
              return _context1.a(2, _t3);
          }
        }, _callee1, this);
      }));
      function listActivity() {
        return _listActivity.apply(this, arguments);
      }
      return listActivity;
    }()
  }, {
    key: "activityCounts",
    value: function () {
      var _activityCounts = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee10() {
        var since, rows, row;
        return _regenerator().w(function (_context10) {
          while (1) switch (_context10.n) {
            case 0:
              if (!this.app.BROWSER) {
                _context10.n = 1;
                break;
              }
              return _context10.a(2, {
                requests: 0,
                requests_recent: 0,
                rejected: 0,
                pending: 0,
                paid: 0,
                failed: 0,
                orphaned: 0
              });
            case 1:
              since = Date.now() - 24 * 60 * 60 * 1000;
              _context10.n = 2;
              return this.app.storage.queryDatabase("SELECT\n         COUNT(*) AS requests,\n         COALESCE(SUM(CASE WHEN created_at >= $since THEN 1 ELSE 0 END), 0) AS requests_recent,\n         COALESCE(SUM(CASE WHEN request_status = 'rejected' THEN 1 ELSE 0 END), 0) AS rejected,\n         COALESCE(SUM(CASE WHEN payment_status IN ('queued', 'broadcast') THEN 1 ELSE 0 END), 0) AS pending,\n         COALESCE(SUM(CASE WHEN payment_status = 'included' AND payment_longest_chain = 1 THEN 1 ELSE 0 END), 0) AS paid,\n         COALESCE(SUM(CASE WHEN payment_status = 'failed' THEN 1 ELSE 0 END), 0) AS failed,\n         COALESCE(SUM(CASE WHEN payment_status = 'orphaned' OR (payment_status = 'included' AND payment_longest_chain = 0) THEN 1 ELSE 0 END), 0) AS orphaned\n       FROM activity", {
                $since: since
              }, this.mod.returnSlug());
            case 2:
              rows = _context10.v;
              row = (rows === null || rows === void 0 ? void 0 : rows[0]) || {};
              return _context10.a(2, {
                requests: Number(row.requests) || 0,
                requests_recent: Number(row.requests_recent) || 0,
                rejected: Number(row.rejected) || 0,
                pending: Number(row.pending) || 0,
                paid: Number(row.paid) || 0,
                failed: Number(row.failed) || 0,
                orphaned: Number(row.orphaned) || 0
              });
          }
        }, _callee10, this);
      }));
      function activityCounts() {
        return _activityCounts.apply(this, arguments);
      }
      return activityCounts;
    }()
  }]);
}();
module.exports = FaucetDB;